angular.module('pitch.search')
.factory('AdvancedFiltersModal', function(config, Modal) {
    return {
        open: function(params, data) {
            return Modal.create(
                config.templateRoot + '/templates/search/advanced-filters-modal',
                params,
                data
            );
        }
    };
});



// WEBPACK FOOTER //
// ./src/SearchClientBundle/Resources/js/angular/services/AdvancedFiltersModal.js